var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M.611,16C.274,16,0,15.833,0,15.626v-2.5c0-.207.274-.374.611-.374H17.078a.792.792,0,0,1,.4.09l2.317,1.251c.274.155.274.412,0,.554L17.478,15.91a.951.951,0,0,1-.4.09Zm0-6.419C.274,9.581,0,9.427,0,9.221v-2.5c0-.205.274-.373.611-.373H12.055a.787.787,0,0,1,.4.09l2.339,1.248a.29.29,0,0,1,0,.554L12.455,9.491a.942.942,0,0,1-.4.09Zm0-6.349C.275,3.232,0,3.065,0,2.871V.374C0,.167.275,0,.614,0H7.044a.8.8,0,0,1,.4.09L9.794,1.339a.289.289,0,0,1,0,.554L7.446,3.142a.959.959,0,0,1-.4.09Z",
    transform: "translate(0 20) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.b0fc2e6e2073f979f486cdff66d2306e.svg";
export { ForwardRef as ReactComponent };